
import React from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';


const SearchControls = props => {
    const {
        makeRequest,
        searchParams,
        refresh
    } = props;

    const search = () => {
        makeRequest();
    };

    const clear = () => {
        refresh();
    };


    return (
        <div className='text-right'>
            <span>
                <Button
                    className = 'usa-button gi-button gi-button__secondary'
                    onClick = { clear }
                >
                    <FormattedMessage id = 'button.clear'/>
                </Button>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    disabled = { !searchParams }
                    onClick = { search }
                >
                    <FormattedMessage id = 'button.search'/>
                </Button>
            </span>
        </div>
    );
};

export default SearchControls;